// import { showSnackbar } from "@/utils/messages";
export default {
  methods: {
    showConfirm(args = {}) {
      // all args:
      // yesCallback
      // noCallback
      // title
      // message
      // yesLabel
      // noLabel
      // yesVariant
      // noVariant
      // headerBgVariant
      let params = {};
      // common args both for custom or predefined snackbar
      params.title = args.title ? args.title : "Conferma";
      params.message = args.message
        ? args.message
        : "Sei sicuro di voler proseguire?";
      params.yesVariant = args.yesVariant ? args.yesVariant : "primary";
      params.noVariant = args.noVariant ? args.noVariant : "-transparent";
      params.headerBgVariant = args.headerBgVariant
        ? args.headerBgVariant
        : "bg-lisaweb";
      params.yesLabel = args.yesLabel ? args.yesLabel : "Sì";
      params.noLabel = args.noLabel ? args.noLabel : "No";
      params.size = args.size ? args.size : "sm";
      params.okDisabled = args.okDisabled ? args.okDisabled : false;
      if (args.yesCallback) {
        params.yesCallback = () => {
          args.yesCallback();
        };
      }
      if (args.noCallback) {
        params.noCallback = () => {
          args.noCallback();
        };
      }
      this.confirm = "";
      this.$bvModal
        .msgBoxConfirm(params.message, {
          title: params.title,
          size: params.size,
          buttonSize: "sm",
          okVariant: params.yesVariant,
          cancelVariant: params.noVariant,
          okTitle: params.yesLabel,
          okDisabled: params.okDisabled,
          cancelTitle: params.noLabel,
          footerClass: "py-2 px-3",
          bodyClass: "pt-3",
          hideHeaderClose: true,
          centered: false,
          headerClass: params.headerBgVariant,
        })
        .then((value) => {
          if (value === true) {
            if (params.yesCallback) {
              params.yesCallback();
              // showSnackbar({
              //   preset: "sucess",
              //   text: `Operazione Eseguita`,
              // });
            } else {
              this.$showSnackbar({
                preset: "info",
                text: `Nessuna operazione eseguita`,
              });
            }
          } else {
            if (params.noCallback) {
              params.noCallback();
            } else {
              this.$showSnackbar({
                preset: "info",
                text: `Operazione annullata`,
              });
            }
          }
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
  },
};
